export default {"src":"/_next/static/media/blackberry_logo.f59a29aa.svg","height":40,"width":230};